/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { $t } from "App/IOC";
import { Column, CustomError } from "App/Models";
import Columns from "App/UseCases/Columns";

let sort: Column;
let columns: Column[] = [];

function GetDefaultSort(): Column {
    if( sort === undefined )
        sort = new Column( "Name", $t( "ROLES_columnName" ) );

    return sort;
}

function getDefault(): Column[] {
    if( columns.length === 0 )
        columns = [
            GetDefaultSort(),
            new Column( "Description", $t( "ROLES_columnDescription" ) ),
            new Column( "Privileges", $t( "ROLES_columnPrivileges" ) ),
            new Column( "UpdatedBy", $t( "ROLES_columnUpdatedBy" ) )
        ];

    return columns;
}

async function Get(): Promise<[ Column[], CustomError | undefined ]> {
    return await Columns.Get( "Roles", getDefault() );
}

async function Toggle( existingColumn: Column ): Promise<CustomError | undefined> {
    return await Columns.Toggle( "Roles", existingColumn, getDefault() );
}

export default {
    GetDefaultSort,
    Get,
    Toggle
};
